(function () {
  function getCm(card) {
    var txt = (card.textContent || '').toLowerCase();
    var m = txt.match(/(\d+(?:[.,]\d+)?)\s*cm/);
    return m ? parseFloat(m[1].replace(',', '.')) : Infinity;
  }

  function getVendor(card) {
    var el = card.querySelector('.product-card__meta');
    return el ? el.textContent.trim().toLowerCase() : '';
  }

  function sortGrid() {
    try {
      var grid = document.getElementById('product-grid');
      if (!grid) return;

      var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
        return el.className && el.className.indexOf('col-sp-6') !== -1;
      });

      if (cards.length < 2) return;

      cards.sort(function (a, b) {

        // Sortare după vendor
        var vendorCompare = getVendor(a).localeCompare(getVendor(b));

        if (vendorCompare !== 0) {
          return vendorCompare;
        }

        // Sortare după cm
        return getCm(a) - getCm(b);
      });

      cards.forEach(function (card) {
        grid.appendChild(card);
      });

    } catch (e) {
      console.log('sort error:', e);
    }
  }

  function run() {
    if (window.location.pathname.indexOf('/search') === -1) return;

    sortGrid();

    setTimeout(sortGrid, 500);
    setTimeout(sortGrid, 1200);
    setTimeout(sortGrid, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();